/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BriefcaseIcon = /*#__PURE__*/ createSvgIcon(
  'BriefcaseIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.5 17c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 012 15.5v-9c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44H7V3.496c0-.414.147-.767.441-1.058A1.452 1.452 0 018.501 2h3.004c.413 0 .766.147 1.057.44.292.294.438.647.438 1.06V5h3.5c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v9c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13zm0-1.5h13v-9h-13v9zM8.5 5h3V3.5h-3V5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default BriefcaseIcon;
